import React from 'react';

export const Card = ({
  children,
  className,
  style,
  innerStyle,
  onClick = () => {}
}) => {
  let styles = getStyles(style, innerStyle);

  return (
    <div className={className} style={styles.container} onClick={onClick}>
      <div style={styles.innerContain}>{children}</div>
    </div>
  );
};

const getStyles = (style = {}, innerStyle = {}) => ({
  innerContain: {
    padding: 16,
    ...innerStyle
  },
  container: {
    flex: 1,
    height: '100%',
    borderRadius: 2,
    margin: '0 8px',
    backgroundColor: '#fff',
    boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.2)',
    ...style
  }
});

export default Card;
